/**
 * Accessibility patch for Typeahead.js 1.2.0 (Kartik widget).
 *
 * Adds the missing combobox ARIA attributes and option semantics without
 * replacing Typeahead's own behaviour or autocomplete.
 */
(function ($) {
    'use strict';

    if (!$) {
        return;
    }

    var MENU_LABEL = 'Результаты поиска';
    var EVENTS = [
        'typeahead:open',
        'typeahead:render',
        'typeahead:close',
        'typeahead:cursorchange',
        'typeahead:select',
        'typeahead:autocomplete'
    ].join('.typeaheadA11y ');

    function menuFor(input) {
        if (!input || !input.id) {
            return null;
        }

        var menu = document.getElementById(input.id + '_listbox');

        if (!menu) {
            // Typeahead 1.2.0 can leave the local .tt-menu without an id
            // while aria-owns already points to <input>_listbox.
            var $input = $(input);
            var $menu = $input.closest('.twitter-typeahead').find('.tt-menu').first();

            if (!$menu.length) {
                $menu = $input.parent().find('.tt-menu').first();
            }

            if ($menu.length) {
                menu = $menu[0];
            }
        }

        if (menu && !menu.id) {
            menu.id = input.id + '_listbox';
        }

        return menu || null;
    }

    function optionId($input, seq) {
        return ($input.attr('id') || 'tt-input') + '_option-' + seq;
    }

    function sync($input, $menu) {
        var inputId = $input.attr('id') || 'tt-input';
        var menuId = $menu.attr('id') || (inputId + '_listbox');
        // Typeahead keeps the .tt-open class after an empty render, so check
        // the real visibility of the listbox as well.
        var open = $menu.hasClass('tt-open') && $menu.is(':visible');

        if (!$menu.attr('id')) {
            $menu.attr('id', menuId);
        }

        var owns = $input.attr('aria-owns');

        if (typeof owns === 'string' && owns !== menuId) {
            $input.attr('aria-owns', menuId);
        }

        $input
            .attr({
                role: 'combobox',
                'aria-controls': menuId,
                'aria-expanded': open ? 'true' : 'false',
                'aria-haspopup': 'listbox'
            })
            .removeAttr('aria-readonly');

        $input.closest('.twitter-typeahead').find('.tt-hint').attr('aria-hidden', 'true');

        $menu
            .removeAttr('aria-expanded')
            .attr({
                role: 'listbox',
                'aria-label': MENU_LABEL
            });

        var seq = parseInt($input.data('ttA11ySeq'), 10) || 0;
        var $suggestions = $menu.find('.tt-suggestion');

        $suggestions.each(function () {
            var $option = $(this);

            if (!this.id) {
                seq += 1;
                this.id = optionId($input, seq);
            }

            $option.attr({
                role: 'option',
                'aria-selected': 'false'
            });
        });

        $input.data('ttA11ySeq', seq);

        var $active = open ? $menu.find('.tt-suggestion.tt-cursor').first() : $();

        if ($active.length && $active.attr('id')) {
            $active.attr('aria-selected', 'true');
            $input.attr('aria-activedescendant', $active.attr('id'));
        } else {
            $input.removeAttr('aria-activedescendant');
        }
    }

    var bootAttempts = 0;
    var BOOT_MAX = 50;
    var BOOT_INTERVAL = 100;

    function patch(input) {
        if (!input) {
            return false;
        }

        var $input = $(input);
        var menu = menuFor(input);

        if (!$input.length || !menu) {
            return false;
        }

        var $menu = $(menu);

        if ($input.data('ttA11yBound')) {
            sync($input, $menu);
            return true;
        }

        var schedule = function () {
            window.setTimeout(function () {
                var current = menuFor(input);

                if (current) {
                    sync($input, $(current));
                }
            }, 0);
        };

        $input.on(EVENTS, schedule);
        $input.on('input.typeaheadA11y keyup.typeaheadA11y', schedule);
        $menu
            .on('mouseover.typeaheadA11y', '.tt-suggestion', schedule)
            .on('mouseleave.typeaheadA11y', schedule);

        $input.data('ttA11yBound', true);
        sync($input, $menu);
        return true;
    }

    function patchWhenReady(input, attempts) {
        attempts = typeof attempts === 'number' ? attempts : 5;

        if (!input || patch(input) || attempts <= 0) {
            return;
        }

        window.setTimeout(function () {
            patchWhenReady(input, attempts - 1);
        }, BOOT_INTERVAL);
    }

    function wrapKvInitTA() {
        var original = window.kvInitTA;

        if (typeof original !== 'function' || original.__typeaheadA11yWrapped) {
            return;
        }

        var wrapped = function (id) {
            var result = original.apply(this, arguments);
            patchWhenReady(document.getElementById(id));
            return result;
        };

        wrapped.__typeaheadA11yWrapped = true;
        window.kvInitTA = wrapped;
    }

    function boot() {
        wrapKvInitTA();

        $('.tt-input').each(function () {
            patchWhenReady(this);
        });

        $('input[data-krajee-typeahead]').each(function () {
            patchWhenReady(this);
        });

        bootAttempts += 1;

        if (bootAttempts < BOOT_MAX) {
            window.setTimeout(boot, BOOT_INTERVAL);
        }
    }

    $(function () {
        boot();

        $(document).on(
            'focusin.typeaheadA11y click.typeaheadA11y',
            'input[data-krajee-typeahead], .tt-input',
            function () {
                patchWhenReady(this);
            }
        );
    });
})(window.jQuery);
